var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-with-banner', {
    attrs: {
      "showFooter": false,
      "isProgressDone": true
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('m-header', {
          attrs: {
            "title": _vm.$t('report.thgBillingOverview.title'),
            "breadCrumbs": _vm.breadCrumbs
          }
        }), _vm.fleetId ? _c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12"
          }
        }, [_c('paginated-table', {
          attrs: {
            "store": _vm.store,
            "headers": _vm.headers,
            "baseQuery": {
              partnerId: _vm.partnerId,
              fleetId: _vm.fleetId
            },
            "loading": _vm.isLoading,
            "sortBy": "timestamp.created",
            "sortDesc": true,
            "isDownloadAsDisplayed": true,
            "controlElements": _vm.controlElements
          },
          scopedSlots: _vm._u([{
            key: "item.timestamp.created",
            fn: function fn(_ref) {
              var item = _ref.item;
              return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.timestamp.created)) + " ")];
            }
          }, {
            key: "item.date",
            fn: function fn(_ref2) {
              var item = _ref2.item;
              return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.date)) + " ")];
            }
          }, {
            key: "item.due",
            fn: function fn(_ref3) {
              var item = _ref3.item;
              return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.due)) + " ")];
            }
          }, {
            key: "item.subTotal",
            fn: function fn(_ref4) {
              var item = _ref4.item;
              return [_c('span', [_vm._v(" " + _vm._s(_vm.formatCurrency(item.subTotal, item.currency)) + " ")])];
            }
          }], null, false, 181790022)
        })], 1)], 1) : _vm._e()];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }